import type { PlanChangeOptionsResponseDowngradeOptionsItemBillingCycle } from './planChangeOptionsResponseDowngradeOptionsItemBillingCycle';
import type { PlanChangeOptionsResponseDowngradeOptionsItemStatus } from './planChangeOptionsResponseDowngradeOptionsItemStatus';

/**
 * 플랜 기본 정보
 */
export type PlanChangeOptionsResponseDowngradeOptionsItem = {
  /** 결제 주기 */
  billingCycle: PlanChangeOptionsResponseDowngradeOptionsItemBillingCycle;
  /** 생성일시 */
  createdAt?: string;
  /** 통화 */
  currency: string;
  /** 플랜 설명 */
  description?: string;
  /** 표시용 플랜 이름 */
  displayName?: string;
  /** 기능 목록 */
  features?: string[];
  /** 플랜 ID */
  id: number;
  /** 활성 상태 */
  isActive?: boolean;
  /** 빌링 플랜 여부 */
  isBillingPlan?: boolean;
  /** 추천 플랜 여부 */
  isRecommended?: boolean;
  /** 최대 사용자 수 */
  maxUsers?: number;
  /** 플랜명 */
  name: string;
  /** 가격 (원 단위) */
  price: number;
  /** 상품 코드 */
  productCode: string;
  /** 상품 ID */
  productId: number;
  /** 정렬 순서 */
  sortOrder?: number;
  /** 플랜 상태 */
  status: PlanChangeOptionsResponseDowngradeOptionsItemStatus;
  /** 저장 공간 제한 (GB) */
  storageLimit?: number;
  /** 무료 체험 일수 */
  trialDays?: number;
  updatedAt?: string;
};
